// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-bar-item {
  cursor: pointer;
  width: 5.375rem;
  height: 3.56rem;
  display: flex;
  position: relative;
  padding-bottom: 2px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.navigation-bar-item--horizontal {
  width: auto;
  flex-direction: row;
  height: auto;
}
.navigation-bar-item__icon {
  font-size: 1.56rem;
  margin-bottom: 4px;
  filter: brightness(0) saturate(100%) invert(85%) sepia(27%) saturate(188%) hue-rotate(156deg) brightness(84%) contrast(91%);
}
.navigation-bar-item__name {
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1;
  letter-spacing: 0;
  text-align: center;
  color: #a6beca;
}
.navigation-bar-item--is-active {
  cursor: default !important;
  pointer-events: none;
}
.navigation-bar-item--is-active .navigation-bar-item__name {
  color: var(--ion-color-light);
}
.navigation-bar-item--is-active .navigation-bar-item__icon {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(36deg) brightness(105%) contrast(101%);
}
.navigation-bar-item--is-active::after {
  content: "";
  height: 2px;
  position: absolute;
  bottom: 1px;
  width: 2.25rem;
  background-color: var(--ion-color-light);
}`, "",{"version":3,"sources":["webpack://./src/app/components/navigation-bar/navigation-item/navigation-item.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACI,WAAA;EACA,mBAAA;EACA,YAAA;AACR;AAEI;EACI,kBAAA;EACA,kBAAA;EACA,2HAAA;AAAR;AAGI;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AADR;AAII;EAEI,0BAAA;EACA,oBAAA;AAHR;AAKQ;EACI,6BAAA;AAHZ;AAMQ;EACI,6HAAA;AAJZ;AAOQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,wCAAA;AALZ","sourcesContent":[".navigation-bar-item {\r\n    cursor: pointer;\r\n    width: 5.375rem;\r\n    height: 3.56rem;\r\n    display: flex;\r\n    position: relative;\r\n    padding-bottom: 2px;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    &--horizontal {\r\n        width: auto;\r\n        flex-direction: row;\r\n        height: auto;\r\n    }\r\n\r\n    &__icon {\r\n        font-size: 1.56rem;\r\n        margin-bottom: 4px;\r\n        filter: brightness(0) saturate(100%) invert(85%) sepia(27%) saturate(188%) hue-rotate(156deg) brightness(84%) contrast(91%);\r\n    }\r\n\r\n    &__name {\r\n        font-weight: 500;\r\n        font-size: 0.75rem;\r\n        line-height: 1;\r\n        letter-spacing: 0;\r\n        text-align: center;\r\n        color: #a6beca;\r\n    }\r\n\r\n    &--is-active {\r\n\r\n        cursor: default !important;\r\n        pointer-events: none;\r\n\r\n        .navigation-bar-item__name {\r\n            color: var(--ion-color-light);\r\n        }\r\n\r\n        .navigation-bar-item__icon {\r\n            filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(36deg) brightness(105%) contrast(101%);\r\n        }\r\n\r\n        &::after {\r\n            content: '';\r\n            height: 2px;\r\n            position: absolute;\r\n            bottom: 1px;\r\n            width: 2.25rem;\r\n            background-color: var(--ion-color-light);\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
